const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#121316]/80 backdrop-blur-md border-t border-[#c2a86e]/40 py-6 px-4">
      <div className="max-w-5xl mx-auto flex flex-col items-center justify-center text-center">

        {/* subtle divider */}
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#c2a86e]/40 to-transparent mb-4" />

        {/* copyright */}
        <p className="text-xs text-[#d6d1c7]/80 tracking-wide font-light">
          &copy; {new Date().getFullYear()}{" "}
          <span className="text-[#c2a86e]">Elijah Soghomonian</span> — All rights reserved.
        </p>

        {/* dev credit */}
        <p className="mt-1 text-[10px] text-[#d6d1c7]/40 tracking-wider">
          Handcrafted by{" "}
          <span className="text-[#c2a86e]/80">Devmint Studios</span>
        </p>

      </div>
    </footer>
  );
};

export default Footer;